import ColorBlock from './ColorBlock';

export default ColorBlock;
